import {yupResolver} from '@hookform/resolvers/yup'
import {SnackbarProvider, enqueueSnackbar} from 'notistack'
import {FC, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {useHoteleria} from '../../../../hooks/useHoteleria'
import {TabModel} from '../../../../models'
import {newBookingSchema} from '../../../../util/validationHoteleria'
import ContainerWrapper from '../../../central/pages/componentes/Container'
import {ResizeHandle} from '../../components/Layout/Container/ResizeHandle/ResizeHandle'
import {ListComponentsHoteleria} from '../../components/components'
import {ModuleModel} from '../../features/modules/models'
import {BookingModel} from '../../models/booking.model'
import {createBookingService} from '../../services/booking.service'
import {getSnackBarToast} from '../../../../util/snackBar'

const getSnackBar = (message: string, variant: boolean) => {
  enqueueSnackbar(message, {
    variant: variant ? 'success' : 'error',
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
  })
}
const renderPanelContent = (key: string | undefined) => {
  let component = <></>
  if (key) {
    component = ListComponentsHoteleria[key]
  }
  return component
}

const CheckoutPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useHoteleria()
  const [, setLoading] = useState(false)
  const methods = useForm<BookingModel>({
    resolver: yupResolver(newBookingSchema),
  })
  const onSubmit = async (data: ModuleModel) => {
    try {
      setLoading(true)
      const response = await createBookingService(data)
      if (!response.data.error) {
        setLoading(false)
        getSnackBarToast('Se creó con éxito', 'success')
        const obj: TabModel = {
          ...currentTabItem,
          showPanel: false,
          idToEdit: '',
          content: {
            headerPanel: 'table-checkout',
          },
        }
        changeCurrentTabItem(obj)
      } else {
        setLoading(false)
        getSnackBarToast(response.data.message, 'error')
      }

      // let num1 = Number(data.Campoadicionalnum1)
      // data.Campoadicionalnum1 = num1
      // let num2 = Number(data.Campoadicionalnum2)
      // data.Campoadicionalnum2 = num2
      // let num3 = Number(data.Campoadicionalnum3)
      // data.Campoadicionalnum3 = num3
      // if (currentTabItem.idToEdit) {
      //   changeCurrentTabItem({...currentTabItem, loadingTable: true, updated: false})
      //   const response = await editModuleService(data)
      //   if (!response.data.error) {
      //     setLoading(false)
      //     getSnackBarToa('Se actualizó el registro correctamente', true)
      //     const obj: TabModel = {
      //       ...currentTabItem,
      //       showPanel: false,
      //       idToEdit: '',
      //       content: {
      //         ...currentTabItem.content,
      //         detailPanel: '',
      //       },
      //       loadingTable: false,
      //       updated: true,
      //     }
      //     changeCurrentTabItem(obj)
      //   } else {
      //     setLoading(false)
      //     changeCurrentTabItem({...currentTabItem, loadingTable: false, updated: false})
      //     getSnackBarToa(response.data.message, false)
      //   }
      // } else {
      //   const response = await createModuleService(data)
      //   if (!response.data.error) {
      //     setLoading(false)
      //     getSnackBarToa('Se creó con éxito', true)
      //     const obj: TabModel = {
      //       ...currentTabItem,
      //       showPanel: false,
      //       idToEdit: '',
      //       content: {
      //         headerPanel: 'table-modules',
      //       },
      //     }
      //     changeCurrentTabItem(obj)
      //   } else {
      //     setLoading(false)
      //     getSnackBarToa(response.data.message, false)
      //   }
      // }
    } catch (error) {
      getSnackBarToast('Hubo un error interno', 'error')
      setLoading(false)
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        {/*<ActionsContent*/}
        {/*    filterClick={handleSearch}*/}
        {/*    updateClick={updateClick}*/}
        {/*  loading={loading}*/}
        {/*  textComponentBack='table-checkout'*/}
        {/*  textComponentGo='form-checkout'*/}
        {/*/>*/}
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical'>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-hoteleria-header-${currentTabItem.title}`}
              id={`panel-hoteleria-header-${currentTabItem.title}`}
              className={'panel__box'}
            >
              {renderPanelContent(currentTabItem.content.headerPanel)}
            </Panel>
            {currentTabItem.showPanel && (
              <>
                <ResizeHandle />
                <Panel
                  className={'panel__box'}
                  collapsible={true}
                  defaultSize={50}
                  order={2}
                  key={`panel-hoteleria-detail-${currentTabItem.title}`}
                  id={`panel-hoteleria-detail-${currentTabItem.title}`}
                >
                  {renderPanelContent(currentTabItem.content.detailPanel)}
                </Panel>
              </>
            )}
          </PanelGroup>
        </ContainerWrapper>
        {/*<ModalSearchHuesped show={showModalSearch} setShow={setShowModalSearch} />*/}
      </form>
      <SnackbarProvider />
    </FormProvider>
  )
}

export {CheckoutPageWrapper}
